var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"user-status"},[(_vm.plan)?_c('span',{attrs:{"small":"","outline":"","color":"success","disabled":""}},[_vm._v(_vm._s(_vm.plan))]):_c('span',{attrs:{"small":"","outline":"","color":"red","disabled":""}},[_vm._v("-")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bbe1b60","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/UserPlanLabel.vue
// module id = null
// module chunks = 